import * as types from '@/store/mutation-types/'

const mutations = {
  /**
   * @param {Object} state
   * @param {Object} data [response data]
   */
  [types.MERGED_NEWS_SUCCESS] (state, data) {
    state.data = data.data
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/merged_news/mutations.js